import { DISTRIBUTOR_FILTER_KEY_V2 } from 'elements/hardwareFilter/distributor/constants'
import { AVAILABILITY_FILTER_KEY_V2 } from 'elements/hardwareFilter/stockAvailability/AvailabilityFilterNodeFactoryV2'
import useHardwareSelectorFetchEngine from 'elements/hardwareSelectorV2/fetch/useHardwareSelectorFetchEngine'
import listQueryParamsFormatter from 'elements/input/listQueryParamsFormatter'
import { useMemo } from 'react'
import type { ComponentTypesV2 } from 'types/selectComponent'
import { majorComponentCategories, otherCategories } from '../configs'
import { useShopHardwareListAbortSignal } from '../hooks/useShopHardwareListAbortSignal'
import { HardwareSupplierFilterKeyType } from '../type'
import ProductGrid from './ProductGrid'

const ALL_TYPES: ComponentTypesV2[] = [...majorComponentCategories, ...otherCategories] as ComponentTypesV2[]

const PAGE_SIZE = 10

type DealsCarouselProps = {
  distributor?: HardwareSupplierFilterKeyType
}

const DealsCarousel = ({ distributor }: DealsCarouselProps) => {
  const listAbortSignal = useShopHardwareListAbortSignal(distributor)

  const defaultFilterValues = useMemo(
    () => ({
      [AVAILABILITY_FILTER_KEY_V2]: 'true',
      has_deals: 'true',
      ...(distributor
        ? { [DISTRIBUTOR_FILTER_KEY_V2]: listQueryParamsFormatter.format({ value: new Set([distributor]) }) }
        : {}),
    }),
    [distributor]
  )

  const { componentsData, loading, loaded, total } = useHardwareSelectorFetchEngine({
    componentTypes: ALL_TYPES,
    defaultFilterValues,
    limit: PAGE_SIZE,
    sortBy: '_distributor_count',
    listAbortSignal,
  })

  const filteredComponentsData = useMemo(() => {
    return componentsData
      ?.map((c) => {
        return {
          ...c,
          ordering_v2: c.ordering_v2?.filter((o) => o.deals?.length > 0),
        }
      })
      .filter((c) => c.ordering_v2?.length > 0)
  }, [componentsData])

  if (loaded && !filteredComponentsData?.length) return null

  return (
    <ProductGrid
      carouselMode={true}
      componentsData={filteredComponentsData}
      title="Deals"
      viewAllLink="/shop/deals"
      category="deals"
      loading={loading}
      isFetching={loading}
      pageSize={PAGE_SIZE}
      totalCount={total}
    />
  )
}

export default DealsCarousel
